import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export function Footer() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);

    const subscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        setBusy(true);
        try {
            await api.post("/newsletter/subscribe", { email });
            toast.success("Welcome to the journal. Check your inbox.");
            setEmail("");
        } catch { toast.error("Could not subscribe. Try again."); }
        setBusy(false);
    };

    return (
        <footer className="bg-[#0A0B09] border-t border-gold/10 relative z-10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
                <div className="grid md:grid-cols-4 gap-12">
                    <div className="md:col-span-2">
                        <h3 className="font-serif text-2xl text-cream mb-3">Join the Spiritual Journal</h3>
                        <p className="text-ash text-sm max-w-md mb-5">Rootwork tips, ritual guides, and word of new offerings, sent with intention.</p>
                        <form onSubmit={subscribe} className="flex gap-2 max-w-md">
                            <input data-testid="footer-newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                placeholder="Your email" className="flex-1 bg-surface border border-gold/20 rounded-full px-5 py-2.5 text-sm text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold" />
                            <button data-testid="footer-newsletter-submit" disabled={busy} className="bg-gold text-ink rounded-full px-6 py-2.5 text-sm font-medium hover:bg-goldbright transition-colors active:scale-95 disabled:opacity-60">
                                {busy ? "..." : "Subscribe"}
                            </button>
                        </form>
                    </div>
                    <div>
                        <div className="overline-label mb-4">Explore</div>
                        <ul className="space-y-2.5 text-sm text-ash">
                            <li><Link to="/shop" className="hover:text-gold">Shop</Link></li>
                            <li><Link to="/services" className="hover:text-gold">Spellwork</Link></li>
                            <li><Link to="/land-defense" className="hover:text-gold">Land Defense</Link></li>
                            <li><Link to="/readings" className="hover:text-gold">Readings</Link></li>
                            <li><Link to="/membership" className="hover:text-gold">Membership</Link></li>
                            <li><Link to="/journal" className="hover:text-gold">Journal</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline-label mb-4">Connect</div>
                        <div className="flex gap-3 mb-4">
                            {[Instagram, Facebook, Youtube, Mail].map((Icon, i) => (
                                <a key={i} href="#" className="w-9 h-9 rounded-full border border-gold/20 flex items-center justify-center text-ash hover:text-gold hover:border-gold/50 transition-colors">
                                    <Icon className="w-4 h-4" />
                                </a>
                            ))}
                        </div>
                        <p className="text-xs text-faded">For guidance and blessing. Results are not guaranteed and services are for spiritual support.</p>
                    </div>
                </div>
                <div className="mt-16 pt-8 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <span className="font-serif text-4xl sm:text-5xl text-cream/10">Sacred Earthworks</span>
                    <p className="text-xs text-faded">© {new Date().getFullYear()} Sacred Earthworks · The Fourth Bluff, Memphis. The iron is in the dirt.</p>
                </div>
            </div>
        </footer>
    );
}
